import styled, { css } from "styled-components";
const Media = {
  Nav: "@media(max-width:1000px)",
  PhoneLarge: "@media(max-width:600px)",
  Laptop: "@media(max-width:1150px)",
};

export const HeaderContainer = styled.header`
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 99999;
  justify-content: space-around;
  padding-top: 1rem;
  min-height: 6rem;
  transition: 0.3s;
  border-radius: 0px 0px 20px 20px;
  background-color: var(--white);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  ${Media.Nav} {
    display: none;
  }

  ${({ isAnimation }) =>
    isAnimation &&
    css`
      transition: 0.3s;
    `};
  ${Media.Nav} {
    align-items: center;
    min-height: 2rem;
  }
  .logo {
    margin-bottom: 1rem;
    img {
      display: block;
      width: 10rem;
      margin: auto;
      ${Media.Nav} {
        width: 4rem;
        margin: inherit;
        margin-bottom: inherit;
      }
    }
  }

  .buttonHeader {
    padding: 1rem;
    background: var(--blue);
    box-shadow: 0px 0px 3px var(--blue);
    border-radius: 15px;
    font-family: "Raleway";
    text-align: center;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: var(--black);
    font-size: 1rem;
    color: var(--white);
  }
`;
